module.exports = __webpack_public_path__ + "img/thumbnail_Nilgai_m_leucistic.62d23663.png";